const GUIDE_STORAGE_KEY = 'scan_guide_read_time';

const GUIDE_EXPIRE_TIME = 60 * 60 * 1000;

export function markGuideRead() {
  localStorage.setItem(
    GUIDE_STORAGE_KEY,
    Date.now().toString(),
  );
}

export function shouldShowGuide() {
  const readTime = localStorage.getItem(
    GUIDE_STORAGE_KEY,
  );

  if (!readTime) {
    return true;
  }

  return (
    Date.now() - Number(readTime)
    > GUIDE_EXPIRE_TIME
  );
}

export function clearGuideStatus() {
  localStorage.removeItem(
    GUIDE_STORAGE_KEY,
  );
}
